import { render, staticRenderFns } from "./UserSubscribedAccountsList.vue?vue&type=template&id=b47983f4&"
import script from "./UserSubscribedAccountsList.vue?vue&type=script&lang=ts&"
export * from "./UserSubscribedAccountsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QList,QInput,QIcon,QItem,QItemSection,QBtn} from 'quasar'
component.options.components = Object.assign({QList,QInput,QIcon,QItem,QItemSection,QBtn}, component.options.components || {})
